import React, { Component } from 'react';
import { NumberInput } from '../components/NumberInput.tsx';
import { ErrorBox } from '../components/ErrorBox.tsx';
import { ICalculationResult, IOverpaymentCalculationRequest } from '../helpers/Models.tsx';
import axios from 'axios';
import { TermSelect } from '../components/TermSelect.tsx';
import FormattedDate from '../components/FormattedDate.tsx';
import { GetStartedButton } from '../components/GetStartedButton.tsx';
import { LenderRow } from '../components/LenderRow.tsx';

interface IProps {
    gtmEvent(): void;
    nextStep(response: string, loadJourney: boolean): void;
    updateLead(props: any): void;
    existingMortgage?: number;
    remainingTerm?: number;
    repayments?: number;
    interestRate?: number;
    overpayBy?: number;
}

interface IState {
    hasError: boolean;
    errors?: string[];
    overpayBy?: number;
    existingMortgage?: number;
    remainingTerm?: number;
    repayments?: number;
    interestRate?: number;
    showNewRemaining: boolean;
    calculationResult?: ICalculationResult;
    calculatingResults: boolean;
    monthsRemaining?: number;
}


export class OverpaymentCalculator extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = { calculatingResults: false, hasError: false, overpayBy: this.props.overpayBy, existingMortgage: this.props.existingMortgage, showNewRemaining: false, remainingTerm: this.props.remainingTerm ?? 25  };
    }

    componentDidMount(): void {
        this.props.gtmEvent();
        if (!this.props.remainingTerm)
            this.props.updateLead({remainingTerm:25});
    }

    nextStep() {
        if (!this.state.existingMortgage) {
            var errors: string[] = [];
            if (!this.state.existingMortgage) {
                errors.push("Mortgage Amount is required");
            }
            this.setState({ errors: errors, hasError: true });
            return;
        }
        this.props.nextStep('Overpayment Calculator', true);
    }

    calculateWithOverpayment() {
        var existingMortgage = this.state.existingMortgage;
        var term = this.state.remainingTerm;
        var repayments = this.state.repayments;
        var interestRate = this.state.interestRate;
        var overpayBy = this.state.overpayBy;
        var errors: string[] = [];
        if (!existingMortgage || !term || (!repayments && !interestRate)) {
            errors.push("Existing mortgage, term and current mortgage repayment are required")
            this.setState({errors: errors, hasError: true});
            return;
        }

        this.setState({calculatingResults: true, errors: [], hasError: false});
        
        var request:IOverpaymentCalculationRequest = {
            mortgageAmount: existingMortgage,
            term: term,
            interestRate: interestRate,
            repayments: repayments,
            overpayBy: overpayBy
        };
        axios.post("/Calculator/CalculateOverpayment", request)
        .then((response) => {
            this.setState({calculatingResults: false, calculationResult: response.data, showNewRemaining: true});
        })
        .catch((error) => {
            this.setState({calculatingResults: false});
            //alert('submit error: ' + error.message);
        });
        // this.setState({checking: true});
    }

    render() {
        var now = new Date();

        return (
            <header className="App-header">
                {/* <h1 className='l'>Switching Calculator</h1>
                <p>Let's talk numbers. Simply add your details to see how much you could save each month.</p>
                <br /> */}
                <div className='wrapper'>
                    <>
                    <div className='row'>
                        <div className='column3'>
                            <NumberInput
                                id='mortgagevalue'
                                key='mortgagevalue'
                                label={<>Outstanding Mortgage <strong>Balance</strong></>}
                                value={this.props.existingMortgage}
                                classes={this.state.hasError && !this.state.existingMortgage ? "e" : ""}
                                onChange={(e) => { this.setState({ existingMortgage: e.target.value }); this.props.updateLead({mortgageType: 'switcher', existingMortgage: e.target.value}); }} />
                        </div>
                        <div className='column3'>
                            <NumberInput
                                id='repayments'
                                key='repayments-scalc'
                                label={<>Current Monthly <strong>Repayments</strong></>}
                                value={this.props.repayments}
                                classes={this.state.hasError && !this.state.repayments ? "e" : ""}
                                onChange={(e) => { this.setState({ repayments: e.target.value }); this.props.updateLead({mortgageType: 'switcher', currentRepayments: e.target.value}); }} />
                        </div>
                        <div className='column3'>
                            <TermSelect 
                                label={<>Remaining <strong>Mortgage Term</strong></>}
                                selectedterm={this.props.remainingTerm}
                                classes={this.state.hasError && !this.state.remainingTerm ? "e" : ""}
                                onChange={(e) => { this.setState({remainingTerm: +e.target.value}); this.props.updateLead({mortgageType: 'switcher', remainingTerm:+e.target.value}); }} />
                            {/* <NumberInput
                                id='interestrate-scalc'
                                key='interestrate-scalc'
                                label={<>Mortgage <strong>Interest Rate</strong></>}
                                value={this.props.interestRate}
                                classes={this.state.hasError && !this.state.interestRate ? "e" : ""}
                                type="percentage"
                                onChange={(e) => { this.setState({ interestRate: e.target.value }); this.props.updateLead({currentInterestRate: e.target.value}); }} /> */}
                        </div>
                    </div>
                    <div className='row' style={{borderTop: '1px solid'}}>
                        <h3>Overpayment details</h3>
                    </div>
                    <div className='row'>
                        <div className='column3'>
                            <NumberInput
                                id='homeValue'
                                key='homeValue'
                                label={<><strong>Increase Monthly Repayments</strong> By</>}
                                value={this.props.overpayBy}
                                classes={this.state.hasError && !this.state.overpayBy ? "e" : ""}
                                onChange={(e) => { this.setState({ overpayBy: e.target.value }); this.props.updateLead({mortgageType: 'switcher', overpayBy: e.target.value}); }} />
                        </div>
                        <div className='column3'>
                            {/* <TermSelect 
                                label={<>Remaining <strong>Mortgage Term</strong></>}
                                selectedterm={this.props.remainingTerm}
                                classes={this.state.hasError && !this.state.remainingTerm ? "e" : ""}
                                onChange={(e) => { this.setState({remainingTerm: +e.target.value}); this.props.updateLead({remainingTerm:+e.target.value}); }} /> */}
                        </div>
                        <div className='column3' style={{ marginTop: 'auto' }}>
                            {!this.state.calculatingResults &&
                                <div className='btn-primary next big' style={{ marginTop: 26 }} onClick={() => this.calculateWithOverpayment()}>Calculate New Term</div>
                            }
                            {this.state.calculatingResults &&
                                <div className='ms-5 loading-spinner'  style={{ marginLeft: 'auto', marginRight: 'auto' }}/>
                            }
                        </div>
                    </div>
                    </>

                    {this.state.hasError &&
                        <ErrorBox hideTitle={true} errors={this.state.errors!} />
                    }

                    {this.state.showNewRemaining && this.state.calculationResult &&
                    <div className='box chartreuse mt-2 ps-0 pe-0'>
                        <div className='row'>
                            <h2>New mortgage end date</h2>
                        </div>

                        <div className='row ps-0 pe-0'>
                        <div className='splitpanelleft ps-0 pe-0'>
                            <div className='row mt-0'>
                                <div className='column2'>
                                    <h1 id='monthly' className='mt-1'><FormattedDate short={true} date={new Date(now.setMonth(now.getMonth()+this.state.calculationResult.monthsRemaining))} /></h1>
                                </div>
                            </div>
                        </div>
                        <div className='splitpanelright ps-0 pe-0'>
                            <div className='row mt-0'>
                                <div className='column2'>
                                    <GetStartedButton 
                                        className='mt-2'
                                        onClick={() => this.nextStep()} />
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    }
                    <div className='row mt-2'>
                        <LenderRow showDisclaimer={true} customDisclaimer={<>
                            <p className='s'>Disclaimer: Our calculators give indicative figures and are based on rates, repayments and amounts entered. They are in no way intended to constitute an offer. Such calculations are made on the presumption that the
                            information supplied by you is accurate and is subject to approval by the actual lender. Rates can change which will impact any saving on term or amount set out.
                            This web page is for illustrative purposes only.</p>
                        </>} />
                    </div>
                </div>
            </header>
        );
    }
}
